import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/common";
import { SignOut } from "@phosphor-icons/react";
import { toast } from "sonner";

const today = () => new Date().toISOString().slice(0, 10);

export function OffboardDialog({ carrier, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [date, setDate] = useState(today());
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (carrier) { setReason(""); setDate(today()); } }, [carrier]);

  const submit = async () => {
    if (!reason.trim()) { toast.error("Please enter the offboarding reason"); return; }
    setSaving(true);
    try {
      await api.post(`/carriers/${carrier.id}/offboard`, { reason, date });
      toast.success(`${carrier.carrier_name} moved to OffBoard Carriers`);
      onDone(); onClose();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!carrier} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white border-slate-200 max-w-md" data-testid="offboard-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Offboard Carrier</DialogTitle>
          <DialogDescription className="text-slate-500">{carrier?.carrier_name} will be removed from Active Carriers and listed under OffBoard Carriers.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-1">
          <Field label="Reason for Offboarding *"><Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} placeholder="e.g. Switched to another dispatch service" className="bg-white border-slate-300" data-testid="offboard-reason" /></Field>
          <Field label="Offboarding Date"><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="bg-white border-slate-300" data-testid="offboard-date" /></Field>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-slate-300 bg-white text-slate-700">Cancel</Button>
          <Button onClick={submit} disabled={saving} className="bg-amber-600 text-white hover:bg-amber-700 font-semibold" data-testid="offboard-confirm-btn">
            <SignOut size={16} className="mr-1.5" />{saving ? "Saving…" : "Offboard Carrier"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
